import { api } from "../utils/api";
import type {
  RestCreateOffer,
  RestOffer,
  RestUpdateOffer,
} from "@KassaroAB/shared/types/offer";
import type { OfferId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  type CatalogScope,
} from "./catalogScope";

const offersPath = (scope: CatalogScope) =>
  catalogCollectionPath(scope, "offers");

export const getOffersApi = (scope: CatalogScope): Promise<RestOffer[]> => {
  return api.get(offersPath(scope));
};

export const getOfferApi = (
  scope: CatalogScope,
  offerId: OfferId,
): Promise<RestOffer> => {
  return api.get(`${offersPath(scope)}/${offerId}`);
};

export const createOfferApi = (
  scope: CatalogScope,
  offer: RestCreateOffer,
): Promise<RestOffer> => {
  return api.post(offersPath(scope), offer);
};

export const updateOfferApi = (
  scope: CatalogScope,
  offerId: OfferId,
  offer: RestUpdateOffer,
): Promise<RestOffer> => {
  return api.put(`${offersPath(scope)}/${offerId}`, offer);
};

export const deleteOfferApi = (
  scope: CatalogScope,
  offerId: OfferId,
): Promise<void> => {
  return api.delete(`${offersPath(scope)}/${offerId}`);
};
